export const document = {
  mode: "ko",
  document: {
    title: "안전한 수출 운영 관리",
    emphasize: "노하우",
    description:
      "셀디코리아는 콰징 수출을 위한 EDI 경영허가, 콰징전자상거래 플랫폼을 직접 운영합니다",
    subDescription:
      "서비스의 신뢰도만큼 중요한, 중국 행정의 제도적 안정성. 믿을 수 있는 행정 운영으로 고객사의 성공적인 중국 진출을 지원합니다.",
  },
};
